import axios from 'axios'

export const state = {
  events: null,
}

export const getters = {
  events: (state) => state.events,
}

export const mutations = {
  SET_EVENTS(state, events) {
    state.events = events
  },
}

export const actions = {
  fetchAllEvents({ commit }, payload) {
    return axios
      .get('/api/events', {
        params: payload,
      })
      .then((response) => {
        const events = response.data
        commit('SET_EVENTS', events)
        return events
      })
  },

  createEvent(_, payload) {
    return axios.post('/api/events', payload)
  },

  viewEvent(_, id) {
    return axios.get(`/api/events/${id}`).then(({ data }) => data)
  },

  updateEvent(_, payload) {
    return axios.put(`/api/events/${payload.id}`, payload)
  },

  deleteEvent(_, id) {
    return axios.delete(`/api/events/${id}`)
  },
}
